import loadable from '@loadable/component';

export const InvitePage = loadable(/* #__LOADABLE__ */ () => import('./InvitePage'));
